import { atom } from 'recoil';

const DATE_RANGE_KEY = 'sf_date_range';

// Custom localStorage effect that handles Date objects
const dateRangeStorageEffect = (key) => ({ setSelf, onSet }) => {
  const savedValue = localStorage.getItem(key);
  if (savedValue != null) {
    try {
      const parsed = JSON.parse(savedValue);
      // If it's an object with start/end, reconstruct Date objects
      if (parsed && typeof parsed === 'object' && parsed.start && parsed.end) {
        setSelf({
          ...parsed,
          start: new Date(parsed.start),
          end: new Date(parsed.end),
          comparison: parsed.comparison ? {
            start: new Date(parsed.comparison.start),
            end: new Date(parsed.comparison.end),
          } : null,
        });
      } else {
        // It's a preset string
        setSelf(parsed);
      }
    } catch (e) {
      // If parsing fails, use the raw string
      setSelf(savedValue);
    }
  }
  onSet((newValue, _, isReset) => {
    if (isReset) {
      localStorage.removeItem(key);
    } else {
      // Serialize dates properly
      if (newValue && typeof newValue === 'object' && newValue.start && newValue.end) {
        const toStore = {
          ...newValue,
          start: newValue.start instanceof Date ? newValue.start.toISOString() : newValue.start,
          end: newValue.end instanceof Date ? newValue.end.toISOString() : newValue.end,
          comparison: newValue.comparison ? {
            start: newValue.comparison.start instanceof Date ? newValue.comparison.start.toISOString() : newValue.comparison.start,
            end: newValue.comparison.end instanceof Date ? newValue.comparison.end.toISOString() : newValue.comparison.end,
          } : null,
        };
        localStorage.setItem(key, JSON.stringify(toStore));
      } else {
        localStorage.setItem(key, JSON.stringify(newValue));
      }
    }
  });
};

// Global date range state - used across Analytics and Reports pages
export const dateRangeAtom = atom({
  key: 'dateRange',
  default: 'today',
  effects: [dateRangeStorageEffect(DATE_RANGE_KEY)],
});
